// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FR-z","hovered":"GR-z","hoverImage":"HR-z","mainImage":"IR-z","imageNoBackground":"JR-z","fullSizeImage":"KR-z"};